(function(angular){
	'use strict';
	
	angular
		.module('ratingsAndReviewsModule')
		.factory('RatingsAndReviewsFactory', [
			'$q',
			'$http',
			'STATIC_BASE_PATH',
			RatingsAndReviewFactoryFunction
		]);
	
	function RatingsAndReviewFactoryFunction(
		$q,
		$http,
		STATIC_BASE_PATH
	) {

		var factory = {
			getFormattedReviews: getFormattedReviews
		};

		return factory;

		function getFormattedReviews() {
			var googleReviewPromise = $http.get(STATIC_BASE_PATH + '/' + resolveStaticResource('static/json/reviews/google-reviews.json'));
			var bbbReviewPromise = $http.get(STATIC_BASE_PATH + '/' + resolveStaticResource('static/json/reviews/bbb-reviews.json'));
			var trustPilotReviewPromise = $http.get(STATIC_BASE_PATH + '/' + resolveStaticResource('static/json/reviews/trustpilot-reviews.json'));

			return $q.all({
				google: googleReviewPromise,
				bbb: bbbReviewPromise,
				trustpilot: trustPilotReviewPromise
			}).then(function(response) {
				return [].concat(
						formatGoogleReviews(response.google.data),
						formatBBBReviews(response.bbb.data),
						formatTrustPilotReviews(response.trustpilot.data));
			});
		}

		function getTeaser(body) {
			if(body.length >= 275) {
				var pos = body.substr(0, 275).lastIndexOf(' ');
				return body.substr(0, pos);
			}
		}

		function formatGoogleReviews(reviews) {
			return reviews.map(function(review) {
				var body = review.body;

				if(body.indexOf('...More') !== -1) {
					body = body.split('...More')[1];
				}

				return {
					source: 'Google',
					imageUrl: review.imageUrl || STATIC_BASE_PATH + '/interface/avatar-default-40x40.svg',
					author: review.author,
					date: new Date(review.date),
					rating: parseFloat(review.rating.slice(42,45)),
					helpfulCount: parseInt(review.helpfulCount),
					body: body,
					teaser: getTeaser(body)
				};
			});
		}

		function formatBBBReviews(reviews) {
			return reviews.map(function(review) {
				var body = review.body.split('Review\n\n            ')[1];

				return {
					source: 'BBB',
					imageUrl: STATIC_BASE_PATH + '/interface/avatar-default-40x40.svg',
					author: review.author,
					date: new Date(review.date),
					rating: review.rating,
					helpfulCount: review.helpfulCount,
					body: body,
					teaser: getTeaser(body)
				};
			});
		}

		function formatTrustPilotReviews(reviews) {
			return reviews.map(function(review) {
				return {
					source: 'Trustpilot',
					imageUrl: STATIC_BASE_PATH + '/interface/avatar-default-40x40.svg',
					author: review['Review Username'],
					date: new Date(review['Review Created (UTC)'].replace(" ", "T")),
					rating: review['Review Stars'],
					helpfulCount: 0,
					body: review['Review Content']
				};
			});
		}
	}
})(window.angular);